export const GLM_52_MODEL_REF = "openrouter/z-ai/glm-5.2";
export const GLM_52_FAST_MODEL_REF = "openrouter/z-ai/glm-5.2:fast";
export const GLM_52_OPENROUTER_MODEL_ID = "z-ai/glm-5.2";
export const GLM_52_FAST_OPENROUTER_MODEL_ALIAS = "z-ai/glm-5.2:fast";
